<template>
  <div>
    <section>
      <q-table
        style="height: 500px"
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        :columns="columns"
        v-model:pagination="pagination"
        class="q-mt-md tabela-tamanho-fixo"
        dense
        row-key="name"
        hide-pagination
        :rows-per-page-options="[0]"
        color="primary"
      >
        <template v-slot:top-right>
          <q-btn
            v-if="mostrarBotaoBuscar"
            color="warning"
            icon="refresh"
            label="Buscar Regras"
            dense
            no-caps
            class="q-mr-sm"
            @click="forcarBuscarGrupos"
          />
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>

        <template #body-cell-grupo_nome="props">
          <q-td style="white-space: normal">
            <div class="row align">
              <span style="width: 210px">{{ props.row.grupo_nome }}</span>
              <span class="q-ml-sm">
                <q-btn
                  color="positive"
                  icon="visibility"
                  dense
                  round
                  @click="getProdutos(props.row.group_id)"
                >
                  <q-tooltip anchor="top middle" self="bottom middle">
                    Ver produtos associados
                  </q-tooltip>
                </q-btn></span
              >
            </div>
          </q-td>
        </template>
        <template #body-cell-remover="props">
          <q-td>
            <q-btn
              color="negative"
              icon="delete"
              dense
              round
              @click="removerGrupo(props.row.group_id)"
            />
          </q-td>
        </template>

        <template #body-cell-prazo_minimo="props">
          <q-td>
            <span v-if="props.row.prazo_minimo">{{
              props.row.prazo_minimo
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>
          </q-td>
        </template>
        <template #body-cell-prazo_maximo="props">
          <q-td>
            <span v-if="props.row.prazo_maximo">{{
              props.row.prazo_maximo
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>
          </q-td>
        </template>

        <template #body-cell-ultima_retirada="props">
          <q-td>
            <div class="row">
              <span v-if="props.row.ultima_retirada">{{
                props.row.ultima_retirada
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}</span>

              <span class="q-ml-sm" v-if="props.row.ultima_retirada">{{
                props.row.ultima_retirada.split(" ")[1]
              }}</span>
            </div>
          </q-td>
        </template>

        <template #body-cell-critico="props">
          <q-td>
            <span v-if="props.row.critico == 0"> NÃO </span>
            <span v-else>SIM</span>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-sm">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          @update:model-value="handleRequest"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="true"
          :direction-links="true"
          size="sm"
        />
      </div>
    </section>

    <section>
      <q-table
        v-if="rows2.length != 0"
        style="height: 500px"
        dense
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows2"
        :loading="disable2"
        :columns="columns2"
        v-model:pagination="pagination"
        class="q-mt-md tabela-tamanho-fixo"
        row-key="name"
        :title="'Produtos do Grupo Selecionado' + ' ' + nomeGrupo"
        :rows-per-page-label="'Linhas Por Página'"
        :rows-per-page-options="[0]"
        hide-pagination
        color="primary"
        @request="handleRequest"
      >
        <template v-slot:top-right>
          <q-btn
            color="negative"
            icon="visibility_off"
            dense
            round
            @click="rows2 = []"
          >
          </q-btn>
        </template>
        <template #body-cell-remover="props">
          <q-td>
            <q-btn
              color="negative"
              icon="delete"
              dense
              round
              @click="removerGrupo(props.row.group_id)"
            />
          </q-td>
        </template>

        <template #body-cell-prazo_minimo="props">
          <q-td>
            <span v-if="props.row.prazo_minimo">{{
              props.row.prazo_minimo
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>
          </q-td>
        </template>
        <template #body-cell-prazo_maximo="props">
          <q-td>
            <span v-if="props.row.prazo_maximo">{{
              props.row.prazo_maximo
                .split(" ")[0]
                .split("-")
                .reverse()
                .join("/")
            }}</span>
          </q-td>
        </template>

        <template #body-cell-ultima_retirada="props">
          <q-td>
            <div class="row">
              <span v-if="props.row.ultima_retirada">{{
                props.row.ultima_retirada
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}</span>

              <span class="q-ml-sm" v-if="props.row.ultima_retirada">{{
                props.row.ultima_retirada.split(" ")[1]
              }}</span>
            </div>
          </q-td>
        </template>

        <template #body-cell-critico="props">
          <q-td>
            <span v-if="props.row.critico == 0"> NÃO </span>
            <span v-else>SIM</span>
          </q-td>
        </template>
      </q-table>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
const columns = [
  {
    name: "grupo_nome",
    label: "Grupo",
    field: "grupo_nome",
    align: "left",
  },
  {
    name: "tipo",
    label: "Tipo Associação",
    field: "tipo",
    align: "left",
  },
  {
    name: "ultima_retirada",
    label: "Ultima Retirada",
    field: "ultima_retirada",
    align: "left",
  },
  {
    name: "quantidade_retirada",
    label: "Já retirou",
    field: "quantidade_retirada",
    align: "left",
  },
  {
    name: "quantidade_total_regra",
    label: "Total da Regra",
    field: "quantidade_total_regra",
    align: "left",
  },
  {
    name: "prazo_minimo",
    label: "Próxima Retirada",
    field: "prazo_minimo",
    align: "left",
  },
  {
    name: "prazo_maximo",
    label: "Prazo Máximo",
    field: "prazo_maximo",
    align: "left",
  },
  {
    name: "critico",
    label: "Crítico?",
    field: "critico",
    align: "left",
  },
  {
    name: "remover",
    label: "Remover",
    field: "remover",
    align: "left",
  },
];

const columns2 = [
  {
    name: "codigo",
    label: "Código",
    field: "codigo",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    field: "descricao",
    align: "left",
  },
];
export default {
  setup() {
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 20,
      rowsNumber: 0,
    });
    const maxPage = ref(1);
    const rows = ref([]);
    const rows2 = ref([]);
    const nomeGrupo = ref("");
    const disable = ref(true);
    const disable2 = ref(false);
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();
    const filtrar = ref("");
    const mostrarBotaoBuscar = ref(false);

    const id = route.params.id;

    const getGrupos = async (page = 1, rowsPerPage = 20) => {
      disable.value = true;
      try {
        let response = await store.dispatch("user/getProdutosGrupos", {
          id,
          page,
          search: filtrar.value,
          per_page: rowsPerPage,
        });

        rows.value = response.data.result.data;

        const currentPage = Number(response.data.result.current_page) || 1;
        const hasNextPage = !!response.data.result.next_page_url;

        pagination.value.page = currentPage;
        pagination.value.rowsPerPage =
          Number(response.data.result.per_page) || rowsPerPage;

        const discoveredMax = currentPage + (hasNextPage ? 1 : 0);
        if (discoveredMax > maxPage.value) {
          maxPage.value = discoveredMax;
        }

        disable.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getProdutos = async (valueId) => {
      disable2.value = true;
      try {
        let response = await store.dispatch("user/getProdutos", {
          id: valueId,
        });

        rows2.value = response.data.model.produtos;
        nomeGrupo.value = response.data.model.name;

        disable2.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      getGrupos(pagination.value.page, pagination.value.rowsPerPage);
    };

    const forcarBuscarGrupos = () => {
      pagination.value.page = 1;
      maxPage.value = 1;
      getGrupos(1, pagination.value.rowsPerPage);
    };

    onMounted(() => {
      setTimeout(() => {
        getGrupos(1, pagination.value.rowsPerPage);
      }, 3000);

      setTimeout(() => {
        if (rows.value.length === 0) {
          mostrarBotaoBuscar.value = true;
        }
      }, 3000);
    });

    const removerGrupo = async (group_id) => {
      try {
        await store.dispatch("user/removerGrupo", {
          id,
          group_id,
        });

        quasar.notify({
          message: "Grupo removido com sucesoo",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getGrupos(pagination.value.page, pagination.value.rowsPerPage);
      } catch (error) {
        quasar.notify({
          message: "Erro ao remover grupo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => filtrar.value,
      () => {
        pagination.value.page = 1;
        maxPage.value = 1;
        getGrupos(1, pagination.value.rowsPerPage);
      }
    );

    return {
      columns,
      rows,
      pagination,
      disable,
      getGrupos,
      pagesNumber: computed(() => maxPage.value),
      handleRequest,
      removerGrupo,
      filtrar,
      columns2,
      getProdutos,
      disable2,
      rows2,
      nomeGrupo,
      mostrarBotaoBuscar,
      forcarBuscarGrupos,
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
}
</style>
